'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = stub;

var _logger = require('../../utils/logger');

var _sequence = require('../../utils/sequence');

var _sequence2 = _interopRequireDefault(_sequence);

var _stubUI = require('../../stubUI/');

var _stubUI2 = _interopRequireDefault(_stubUI);

var _apiStubLoader = require('./apiStubLoader');

var _apiStubLoader2 = _interopRequireDefault(_apiStubLoader);

var _delayedActionsFactory = require('./delayedActionsFactory');

var _delayedActionsFactory2 = _interopRequireDefault(_delayedActionsFactory);

var _topicDictionaryFactory = require('./topicDictionaryFactory');

var _topicDictionaryFactory2 = _interopRequireDefault(_topicDictionaryFactory);

var _stubSessionFactory = require('./stubSessionFactory');

var _stubSessionFactory2 = _interopRequireDefault(_stubSessionFactory);

var _domConfigurationStrategy = require('../domConfigurationStrategy');

var _domConfigurationStrategy2 = _interopRequireDefault(_domConfigurationStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = (0, _logger.create)('Stub provider');

function createSequenceAction(topicDictionary, delayedActions) {
    return function (_ref) {
        var topic = _ref.topic,
            value = _ref.value;

        if (topicDictionary.keys().includes(topic)) {
            topicDictionary.update(topic, value);
        } else {
            delayedActions.add(topic, value);
        }
    };
}

function stub() {
    var currentSession = void 0;
    var topicDictionary = (0, _topicDictionaryFactory2.default)();
    var delayedActions = (0, _delayedActionsFactory2.default)();
    var sequenceAction = createSequenceAction(topicDictionary, delayedActions);
    var mainSequence = (0, _sequence2.default)(sequenceAction);

    function enableStubUI() {
        var next = mainSequence.next,
            play = mainSequence.play,
            reset = mainSequence.reset;

        var steps = mainSequence.getSteps();
        if (steps.length > 1) {
            var ui = new _stubUI2.default({ next: next, play: play, reset: reset });
            ui.init();
        }
    }

    function setValue(topic, value, step) {
        mainSequence.addValues([{ topic: topic, value: value, step: step }]);
    }

    function setValues(values) {
        mainSequence.addValues(values);
    }

    function provider() {
        var configurationStrategy = (0, _domConfigurationStrategy2.default)();
        return (0, _apiStubLoader2.default)(configurationStrategy.getStubConfig()).then(function (values) {
            if (values) {
                setValues(values);
                enableStubUI();
                mainSequence.next();
            }
        }).then(function () {
            return currentSession = (0, _stubSessionFactory2.default)(topicDictionary, delayedActions);
        }).catch(logger.error);
    }

    return {
        play: function play() {
            var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5000;
            return mainSequence.play(interval);
        },
        next: function next() {
            return mainSequence.next();
        },
        reset: function reset() {
            return mainSequence.reset();
        },
        getSubscribedTopics: function getSubscribedTopics() {
            return currentSession.getSubscribedTopics();
        },
        getPageTopics: topicDictionary.keys,
        log: _logger.setLevel,
        provider: provider,
        setValue: setValue,
        setValues: setValues
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/providers/stub/index.js
// module id = 1864
// module chunks = 1